module.exports = __webpack_public_path__ + "static/media/PAGE_SITE_HIASECURE_SHOWROOM-2.497b7766.jpg";